'use client';

import React, { createContext, useContext, useState, ReactNode } from 'react';
interface CalculatorContextType {
  progress: number;
  setProgress: (value: number) => void;
  RecentDate: {
    [key: string]: any;
  };
  setRecentData: (data: {
    [key: string]: any;
  }) => void;
  setCountry: (value: string | undefined) => void;
  country: string | undefined;
  setCountryCode: (value: string | undefined) => void;
  countryCode: string | undefined;
}
const CalculatorContext = createContext<CalculatorContextType | undefined>(undefined);
export const CalculatorProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [progress, setProgress] = useState<number>(0);
  const [countryCode, setCountryCode] = useState<string | undefined>('');
  const [country, setCountry] = useState<string | undefined>('');
  const [RecentDate, setRecentData] = useState<{
    [key: string]: any;
  }>({});
  return <CalculatorContext.Provider value={{
    progress,
    setProgress,
    RecentDate,
    setRecentData,
    setCountry,
    country,
    setCountryCode,
    countryCode
  }} data-sentry-element="unknown" data-sentry-component="CalculatorProvider" data-sentry-source-file="CalculatorContext.tsx">
            {children}
        </CalculatorContext.Provider>;
};
export const useCalculatorContext = () => {
  const context = useContext(CalculatorContext);
  if (!context) {
    throw new Error('useCalculatorContext must be used within a CalculatorProvider');
  }
  return context;
};